import { WifiOff } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { useSession } from '@/shared/auth';
import { t } from '@/shared/i18n';
import { springs } from '@/shared/lib/motion';
import { useConnectionState } from '@/shared/realtime';

import styles from './ConnectionBar.module.scss';

/**
 * Тонкая полоска «нет связи» над содержимым. Показывается не сразу: при
 * входе и при обычном переподключении соединение восстанавливается за
 * секунду, и мигать полоской незачем.
 *
 * Без неё отсутствие связи незаметно: экран выглядит как обычно, но чужие
 * правки не долетают, и человек уверен, что видит свежее.
 */
export function ConnectionBar() {
  const state = useConnectionState();
  const session = useSession();
  // «Давно офлайн» взводится таймером; само «офлайн сейчас» считается при
  // рендере.
  const [longOffline, setLongOffline] = useState(false);
  const offline = state !== 'online' && session.status === 'authenticated';

  useEffect(() => {
    if (!offline) {
      return;
    }

    const timer = setTimeout(() => {
      setLongOffline(true);
    }, 2500);

    return () => {
      clearTimeout(timer);
      setLongOffline(false);
    };
  }, [offline]);

  return (
    <AnimatePresence>
      {offline && longOffline && (
        <motion.div
          key="offline"
          className={styles['bar']}
          role="status"
          initial={{ y: -28, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -28, opacity: 0 }}
          transition={springs.rubber}
        >
          <WifiOff />
          {t.live.offline}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
